import { render, staticRenderFns } from "./LoginProviderTutoWeb.vue?vue&type=template&id=c8582d5a&scoped=true&"
import script from "./LoginProviderTutoWeb.vue?vue&type=script&lang=js&"
export * from "./LoginProviderTutoWeb.vue?vue&type=script&lang=js&"
import style0 from "./LoginProviderTutoWeb.vue?vue&type=style&index=0&id=c8582d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8582d5a",
  null
  
)

export default component.exports